import { DescrittoreSezione } from './descrittore-sezione';

export class PrivateUtilServiceObject {
    descrittori: DescrittoreSezione[];
    mandatoryNotCompiled: number;
    assegnazioneSmistamento: boolean;
    assegnazioneCompetenza: boolean;
    legali: boolean;
}
